import api from "./axios";

export const admin_dashboardApi = () => {
    return api.get("/admin_dashboard/admin_data");
}

// Paginated: params = { page, page_size, search, user_status }.
// Response `data` is the page of users; `meta` has page/page_size/total/total_pages.
export const user_managementApi = (params = {}) => {
    return api.get("/admin_dashboard/users_list", { params });
}

export const admin_impersonateApi = (userId) => {
    return api.post(`/admin_dashboard/impersonate/?target_user_id=${userId}`);
}

export const get_user_according_to_date_rangeApi = (startDate, endDate) => {
    return api.get("/admin_dashboard/get_user_according_to_date_range", {
        params: {
            start_date: startDate,
            end_date: endDate
        }
    });
};

export const get_new_users_according_to_date_range = (startDate, endDate) => {
    return api.get("/admin_dashboard/get_new_users_according_to_date_range", {
        params: {
            start_date: startDate,
            end_date: endDate
        }
    });
};
// export const get_new_users_according_to_date_range = (start_date, end_date) => {
//     return api.post("/admin_dashboard/get_new_users_according_to_date_range", {
//         start_date,
//         end_date
//     });
// }

export const updateUserApi = async (userId, data) => {
    return api.put(`/admin_dashboard/update_user_details/${userId}`, data);
  };
  
  // Delete user
  export const deleteUserApi = async (userId) => {
    return api.delete(`/admin_dashboard/delete_user/${userId}`);
  };

export const get_team_memebersApi = () => {
    return api.get("/admin_dashboard/get_team_memebers");
}

export const register_team_memberApi = (payload) => {
    return api.post("/auth/register", payload);
}

export const get_ai_usage_stats = (params = {}) => {
    return api.get("/admin/ai-usage/stats", { params });
}

export const get_ai_configurations = () => {
    return api.get("/admin/ai-configuration/");
}

export const get_available_ai_providers = () => {
    return api.get("/admin/ai-configuration/available-providers");
}

export const get_available_ai_features = () => {
    return api.get("/admin/ai-configuration/available-features");
}

export const create_ai_configuration = (payload) => {
    return api.post("/admin/ai-configuration/", payload);
}

export const update_ai_configuration = (feature_name, payload) => {
    return api.put(`/admin/ai-configuration/feature/${feature_name}`, payload);
}

export const delete_ai_configuration = (feature_name) => {
    return api.delete(`/admin/ai-configuration/feature/${feature_name}`);
}

export const toggle_ai_configuration = (feature_name, enabled) => {
    return api.patch(`/admin/ai-configuration/feature/${feature_name}/toggle`, null, {
        params: { enabled },
    });
}

export const test_ai_configuration = (payload) => {
    return api.post("/admin/ai-testing/test", payload);
}

export const get_static_test_content = (feature_name) => {
    return api.get(`/admin/ai-testing/static-content/${feature_name}`);
}

// ── Library-first test content (preferred for the playground) ───────────────
// `get_resolved_test_content` lazily seeds from the static file on first read,
// so opening a feature's playground tab once is enough to make its preset
// editable. The returned payload always includes `id`, which is the library
// row to PUT subsequent edits against.
export const get_resolved_test_content = (feature_name) => {
    return api.get(`/admin/ai-testing/test-content/${feature_name}`);
}

export const update_test_content_library = (content_id, payload) => {
    return api.put(`/admin/ai-testing/content-library/${content_id}`, payload);
}

export const seed_test_content_defaults = () => {
    return api.post(`/admin/ai-testing/test-content/seed`);
}

export const get_user_ga4_properties = (user_id) => {
    return api.get("/admin_dashboard/get_user_ga4_properties/", {
        params: { user_id },
    });
};

export const build_analytics_summary_test_content = (payload) => {
    return api.post("/admin/ai-testing/analytics-summary/build-test-content", payload);
};

export const generate_web_analytics_summary = (payload) => {
    return api.post("/web-analytics-summaries/generate", payload);
};

// ── AI Providers catalog (admin-managed) ────────────────────────────────────
// model_id may contain "/" and ":" (e.g. "openai/gpt-oss-120b",
// "deepseek/deepseek-r1-0528:free"). The backend route uses {model_id:path}
// so slashes/colons MUST pass through unencoded — we build paths from raw
// strings and let axios send them as-is.

export const get_supported_ai_provider_keys = () => {
    return api.get("/admin/ai-providers/supported");
};

export const list_ai_providers = () => {
    return api.get("/admin/ai-providers");
};

export const get_ai_provider = (provider_key) => {
    return api.get(`/admin/ai-providers/${provider_key}`);
};

export const create_ai_provider = (payload) => {
    return api.post("/admin/ai-providers", payload);
};

export const update_ai_provider = (provider_key, payload) => {
    return api.put(`/admin/ai-providers/${provider_key}`, payload);
};

export const delete_ai_provider = (provider_key) => {
    return api.delete(`/admin/ai-providers/${provider_key}`);
};

export const toggle_ai_provider = (provider_key, enabled) => {
    return api.patch(`/admin/ai-providers/${provider_key}/toggle`, null, {
        params: { enabled },
    });
};

// Saving a model now runs a smoke test server-side by default. Pass
// `skip_test: true` to bypass it (used by the "Save anyway" retry after a
// failed automatic test).
export const add_ai_provider_model = (provider_key, payload, { skip_test = false } = {}) => {
    return api.post(`/admin/ai-providers/${provider_key}/models`, payload, {
        params: skip_test ? { skip_test: true } : undefined,
    });
};

export const update_ai_provider_model = (provider_key, model_id, payload) => {
    return api.patch(
        `/admin/ai-providers/${provider_key}/models/${model_id}`,
        payload
    );
};

export const delete_ai_provider_model = (provider_key, model_id) => {
    return api.delete(`/admin/ai-providers/${provider_key}/models/${model_id}`);
};

// Smoke tests
//   • test_ai_provider_connection — ad-hoc test using credentials from the
//     form (used while creating a provider, before anything is saved).
//   • test_ai_provider_saved      — uses the provider's saved API key /
//     base_url; only the model_id (and optional prompt overrides) are sent.
export const test_ai_provider_connection = (payload) => {
    return api.post("/admin/ai-providers/test-connection", payload);
};

export const test_ai_provider_saved = (provider_key, payload) => {
    return api.post(`/admin/ai-providers/${provider_key}/test`, payload);
};